import { cryptoFetch } from 'crypto-fetch'
import i18n from '@ms/lang/i18n.js'
import { ALL_SELECTIONS_UNAVAILABLE, ORDER_MAY_FAILED } from '@ms/config/message.js'
import { apiMoney } from '@ms/utils-es/math'
import { getPlaceSelections } from '@ms/components/betslip/core/getPlaceBody.js'
import { useBetslipStore } from '@ms/stores/betslip'

// 下单 api
export const placeBet = async (body) => {
  if (body.ticket.selections.length === 0 || body.ticket.bets.length === 0) {
    return Promise.reject(new Error(ALL_SELECTIONS_UNAVAILABLE))
  }
  try {
    const sharecode = localStorage.getItem('sharecode')
    if (sharecode) {
      body.code = sharecode
    }
    const res = await cryptoFetch('/orders/order', body, 2)

    const { bizCode, data, message } = res
    if (bizCode === 10000) {
      sharecode && localStorage.removeItem('sharecode')
      return data
    } else {
      // mts rejected
      const hasRejectedSelections = bizCode === 4300 && data && data.rejectSelections
      if (hasRejectedSelections) {
        useBetslipStore().setRejectSelections(data.rejectSelections)
      }
      const error = new Error(message)
      error.bizCode = bizCode
      error.data = data
      return Promise.reject(error)
    }
  } catch (error) {
    console.error(error)
    // nginx 超时
    if (error.status === 504) {
      return Promise.reject(new Error(ORDER_MAY_FAILED))
    }
    return Promise.reject(error)
  }
}

// 快速投注
export const fastPlaceOrder = async ({ stake, actualPayAmount, formSelections, voucher } = {}) => {
  const body = {
    bizType: 1, // 1代表真实体育，这里我们只填写1
    orderType: 1, // 1代表SingleBet，每个选项下一注
    ticket: {
      selections: getPlaceSelections(formSelections),
      bets: [
        {
          stake: {
            value: apiMoney(stake)
          }
        }
      ]
    },
    currency: i18n.t('CURRENCY')
  }
  // 使用红包
  if (voucher) {
    body.favor = {
      favorInfo: [
        {
          giftId: voucher.id
        }
      ]
    }
    // 实际支付金额，扣掉红包之后的金额，没用红包可以不填写, *10000之后的数值
    body.actualPayAmount = apiMoney(actualPayAmount)
  }
  body.source = 'fast'
  const res = await placeBet(body)
  return res
}
